import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";

export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("rounded-ge-card border border-ge-border-card bg-ge-card", className)}
      {...props}
    />
  ),
);
Card.displayName = "Card";
